import { from } from 'rxjs'

import { ConversationAPI } from 'api'
import { rxCheckStatus, rxRetryWithBackoff } from 'utils/api'
export const api = {
  updateInbox(id, properties) {
    return from(ConversationAPI.patch(`/inboxes/${id}`, properties)).pipe(
      rxCheckStatus(),
      rxRetryWithBackoff()
    )
  },
}
